exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5f11028","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"/Users/pola/Documents/udemy/prototype_boxed_layout/src/assets/scss/variables.scss/";"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cheap.vue
// module id = 166
// module chunks = 0